<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
    </window-tab>
    <window-tab title="Data" icon="database">
      <album-select-group v-model="albumId"></album-select-group>
      <picture-select-group v-model="pictureId" :album-id="albumId"></picture-select-group>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import mapOverlayData from '../../utils/mapOverlayData'
  import mapTemplateData from '../../utils/mapTemplateData'

  export default {
    name: 'station-bug',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['picture']),
      ...mapTemplateData(['albumId', 'pictureId'])
    },
    watch: {
      pictureId: function (val) {
        this.picture = this.$store.getters.picture(this.albumId, val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/custom-bug.vue